import { render, staticRenderFns } from "./ContestActionTemplate.vue?vue&type=template&id=e6e8a590&scoped=true&"
import script from "./ContestActionTemplate.vue?vue&type=script&lang=js&"
export * from "./ContestActionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e8a590",
  null
  
)

export default component.exports